import { DashboardApi } from '../dashboard-api';
import { DashboardDetail } from './dashboard-detail';

export interface DashboadWidgetRename {
  dashboardId: string;
  widgetId: string;
  name: string;
}

export async function renameDashboardDetailWidget(
  widgetId: string,
  name: string,
  api: DashboardApi,
  getModel: () => DashboardDetail,
  update: (_: DashboardDetail) => void
) {
  const model = getModel();
  const widget = model.widgets.find((w) => w.id === widgetId);
  if (!widget) {
    return;
  }

  const newName = name.trim() || null;

  const widgets = model.widgets.map((w) => (w.id !== widgetId ? w : { ...w, name: newName, rename: undefined }));

  update({ ...model, widgets });

  const res = await api.updateWidget(model.id, widget.id, { name: newName });

  if (!res?.ok) {
    return { message: 'Error renaming widget.' };
  }
}
